export interface ChatComponent {
  type: string;
  data: Record<string, any>;
}

export interface ChatMessage {
  id: string;
  text: string;
  sender: ChatMessageType;
  timestamp: Date;
  isStreaming?: boolean;
  type?: ChatMessageType;
  components?: ChatComponent[];
}

export interface ChatBotConfig {
  welcomeMessage?: string;
  placeholder?: string;
  botName?: string;
  apiEndpoint?: string;
  baseURL?: string;
  sessionId?: string;
  authToken?: string;
  skipInitialLoad?: boolean;
}

export enum ChatMessageType {
  USER = 'user',
  BOT = 'bot',
  ALERT = 'alert',
  SESSION_FEEDBACK = 'session_feedback',
}

export type InformationOptions = {
  [category: string]: string[];
};